import { render, staticRenderFns } from "./App4Bar.vue?vue&type=template&id=3ba7bd5f&"
import script from "./App4Bar.vue?vue&type=script&lang=js&"
export * from "./App4Bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports